import { memo, useEffect, useMemo, useState } from 'react';
import CharacterSpot from './components/CharacterSpot';
import _ from 'lodash';
import { characterSpots } from './instance';
import { animated, useTransition } from '@react-spring/web';
import { CharacterRoutePlaceInfo } from '@/store/types';
import BackgroundAnimate from '@/components/BackgroundAnimate';
import { useStore } from '@/store';
import { PageMode } from '@/store/types';
import { useQueryGetAllRouteData } from '@/services/hooks';
import QrCode from '@/components/QrCode';
import { driveDigitalHumanByText } from '@/pages/DigitalHuman/util/tts-manage';

const TravelLine = memo(() => {
  // const isCharacterRouteMode = useStore((state) => state.mode=== PageMode.CHARACTER_ROUTE) ;
  // const routeDetailId = useStore((state) => state.routeDetailId);
  const mode = useStore((state) => state.mode);
  // const indexRef = useRef(0);
  const [curIndex, setCurIndex] = useState(0);
  const [list, setList] = useState<CharacterRoutePlaceInfo[]>([]);

  const { data } = useQueryGetAllRouteData();


  // 语音控制
  useEffect(()=>{
    driveDigitalHumanByText('这些西湖文学人物从“时间脉络、精神光谱、地标互文”三个维度勾勒西湖千年文脉。');
  },[])

  useEffect(() => {
    if (mode === PageMode.ROUTE_CHARACTER_LIST) {
      const arr: any = data?.charaterList?.filter(item => item.name !== '旭烽叙事 灵性西湖')
        ?.sort((a: any, b: any) => a.hot - b.hot)
        ?.map((item, index) => ({
          ...item, 
          x: characterSpots[index % 6].x,
          y: index > 5 ?
            index > 11 ?
              63 : 40 :
            characterSpots[index % 6].y
        }));
      setList(arr);
    }
  }, [mode]);

  const transitions = useTransition(curIndex, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 500 },
  });

  // useEffect(() => {
  //   let timer: any = null;
  //   if (list.length > 1 && !routeDetailId) {
  //     timer = setInterval(() => {
  //       indexRef.current += 1;
  //       if (indexRef.current > list.length - 1) {
  //         indexRef.current = 0;
  //       }
  //       setCurIndex(indexRef.current);
  //     }, 10000);

  //     return () => {
  //       clearInterval(timer);
  //     }
  //   } else {
  //     return () => {
  //       clearInterval(timer);
  //     }
  //   }
  // }, [list, routeDetailId]);

  // console.log('isCharacterRouteMode', isCharacterRouteMode);
  return (
    <BackgroundAnimate visible={true} animate opacity={1} loop>
      {
        transitions((style, item) =>
          <animated.div style={{ ...style, width: '100%', height: '100%', position: 'relative' }}>
            {
              list?.map((spot, index) => (
                <CharacterSpot
                  key={spot.entity_id}
                  card={spot}
                  index={index}
                />
              ))
            }
          </animated.div>
        )
      }
      <QrCode />
    </BackgroundAnimate>
  );
});

export default TravelLine; 